// extracted by mini-css-extract-plugin
export var subtitle = "_cn-2";
export var title = "_cn-0";
export var titleNoWrap = "_cn-1";